/**
 * @generated SignedSource<<0d10daa4d2d58d4a99503f3d6fb7a0ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProductModelInput = {
  _id: string;
  availableQuantity: number;
  barcode: string;
  description: string;
  imageUrl: string;
  name: string;
  price: number;
};
export type ProductModal_update_Mutation$variables = {
  data: ProductModelInput;
};
export type ProductModal_update_Mutation$data = {
  readonly updateProduct: {
    readonly _id: string;
  };
};
export type ProductModal_update_Mutation = {
  response: ProductModal_update_Mutation$data;
  variables: ProductModal_update_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "ProductIdModel",
    "kind": "LinkedField",
    "name": "updateProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductModal_update_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductModal_update_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3dea76f7547c67b0515951855f84c5ed",
    "id": null,
    "metadata": {},
    "name": "ProductModal_update_Mutation",
    "operationKind": "mutation",
    "text": "mutation ProductModal_update_Mutation(\n  $data: ProductModelInput!\n) {\n  updateProduct(data: $data) {\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bddb170331a4eb4dab3b30444a21a5c2";

export default node;
